<template>
  <div>
    <div
      class="row p-4"
      v-if="(orderLength <= 0)"
    >
      <p
        class="col-12 text-center"
        id="'user-no-order"
								data-test="orderGiftCardNoCard"
      >
        No Gift Card Ordered Yet
      </p>
      <br>
    </div>
    <div
      v-for="(order,key) in orders"
      class="order-item"
      :key="key"
      v-else
    >
      <h6 :id="'user-order-no-'+key"
										:data-test="'orderGiftCardOrderNo'+key">
        Order No:
        <span
          class="order-number"
          :id="'user-order-no-link-'+key"
          style="color: #2874f0"
										:data-test="'orderGiftCardOrderNoSpan'+key"
        >
          {{(order.order_number+'').toUpperCase()}}
        </span>
      </h6>
      <div
        class="cart-wrapper"
        v-for="(product, index) in order.orderProductDetails"
        :key="product.product_id+'_'+product.order_detail_id"
      >
        <div class="left">
          <div class="cart-items-wrapper">
            <div class="cart-item">
              <div class="cart-grid">
                <div class="cart-contents-wrapper">
                  <div class="description">
                    <div
                      class="pricy"
                      v-if="!product.promotion_id"
                    >
                      <span :data-test="'orderGiftCardPdtPrice'+index"
																												:id="'orderGiftCardPdtPrice'+index">
                        {{product.price | currencyConversion}}
                      </span>
                      <!--<span>50% off</span>-->
                    </div>
                  </div>
                </div>
                <div class="cart-image-warpper">
                  <img
                    class="cart-product-image"
                    src="@/assets/svg/gift-card.svg"
                    alt="Product Image"
																				:data-test="'orderGiftCardImg'+index"
																				:id="'orderGiftCardImg'+index"
                  >
                  <div class="quantity-warpper">
                    <span class=""
																										:data-test="'orderGiftCardQty'+index"
																										:id="'orderGiftCardQty'+index">
                      Qty: {{product.quantity}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'ordered-gift-cards',
	computed: {
		...mapGetters('order', ['getTotalOrderData'])
	},
	data () {
		return {
			orders: [],
			orderLength: 0,
			showLoader: true
		}
	},
	mounted () {
		this.orders = this.getTotalOrderData.gift_cards

		this.orderLength = this.orders.length
		this.$forceUpdate()
	},
	watch: {
		getTotalOrderData () {
			this.orders = this.getTotalOrderData.gift_cards

			this.orderLength = this.orders.length
			this.$forceUpdate()
		}
	}
}
</script>

<style scoped>
</style>
